// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV3GetOffersRequest,
  TPublicB2cV3GetOffersModel,
  IMappers,
  TPublicB2cV3GetOffersResponse,
  TPublicB2cV3GetOffersResponse_1,
  TPublicB2cV3GetOffersResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TPublicB2cV3GetOffersModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'mortgage-broker-calculator',
  pathApi: '/b2c/v3/get-offers/',
  requestType: 'json',
} as TPublicB2cV3GetOffersModel;

export function createPublicB2cV3GetOffersModel(parameters: TPublicB2cV3GetOffersRequest): TPublicB2cV3GetOffersModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicB2cV3GetOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV3GetOffersRequest;
}

export async function fetchPublicB2cV3GetOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV3GetOffersOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV3GetOffersResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createPublicB2cV3GetOffersModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV3GetOffersResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV3GetOffersResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicB2cV3GetOffersResponse;
}
